var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobexd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_22258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.77778C0 3.4825 3.4825 0 7.77778 0H62.2222C66.5175 0 70 3.4825 70 7.77778V62.2222C70 66.5175 66.5175 70 62.2222 70H7.77778C3.4825 70 0 66.5175 0 62.2222V7.77778Z",
    fill: "#FF41C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 5.83301V64.1663H64.1654V5.83301H5.83203ZM25.4573 30.5177L29.179 21.023H35.5781L29.0837 34.7333L35.7298 48.6711H29.2548L25.4573 39.0052L21.6793 48.6711H15.2043L21.8504 34.7333L15.3365 21.023H21.7356L25.4573 30.5177ZM37.0773 37.7725C37.0773 34.4047 37.647 31.8925 38.7865 30.2338C39.9259 28.5752 41.5826 27.7469 43.7623 27.7469C45.3431 27.7469 46.6615 28.4313 47.7115 29.7983V19.5063H53.1229V48.673H48.2423L47.9954 46.5847C46.8948 48.2316 45.4754 49.0541 43.7409 49.0541C41.5904 49.0541 39.9473 48.2316 38.8137 46.5847C37.6801 44.9377 37.1006 42.5208 37.0754 39.3319L37.0773 37.7725ZM42.4712 39.1199C42.4712 41.1461 42.6851 42.5616 43.1167 43.3647C43.5484 44.1677 44.2756 44.5702 45.3004 44.5702C46.364 44.5702 47.167 44.0958 47.7115 43.1469V33.7669C47.1806 32.7538 46.3815 32.2483 45.3198 32.2483C44.332 32.2483 43.6106 32.6469 43.1556 33.4441C42.7006 34.2413 42.4712 35.6608 42.4712 37.6986V39.1199Z",
    fill: "#16020B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_22258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobexd);
export default __webpack_public_path__ + "static/media/adobexd.21c7926e0347ced57173026fae142b80.svg";
export { ForwardRef as ReactComponent };